// extracted by mini-css-extract-plugin
export default {"mobileName":"cssHelperClasses_mobileName__jgF4O","zigZagTop":"cssHelperClasses_zigZagTop__wBJ9u","zigZagBottom":"cssHelperClasses_zigZagBottom__PN6kH"};